import React from "react";
import './PeopleClient.scss';

export default function PeopleCard({d,i,total}){
    var image = `//uws.njit.edu/ldapimage.php?uid=${d.ucid}&format=thumb`
    var url = `https://people.njit.edu/profile/${d.ucid}`
    var numOfCardsWithoutBorder = total%2==0? 2:1;

    const buttonClicked = () =>{
        window.location.href=`https://people.njit.edu/profile/${d.ucid}`;
    }
    return(
            <div className={i<total-numOfCardsWithoutBorder? "card with-border":"card"}>
                <div className="card-left">
                    <img src={image} alt="Card" className="image" />
                </div>
                <div className="card-right">
                    <div className="info-container">
                        <h2 className="title">{d.display_name}</h2>
                        <span>{d.title}</span><br/>
                        <span>{d.department.title}</span>
                    </div>
                    <a><button onClick={buttonClicked}>VIEW PROFILE</button></a>
                </div>
            </div>
    )
}


// WEBPACK FOOTER //
// ./src/PeopleClient/PeopleCard.js